import { render, staticRenderFns } from "./PnetMessageViewSideMenu.vue?vue&type=template&id=74d15d36"
import script from "./PnetMessageViewSideMenu.vue?vue&type=script&lang=js"
export * from "./PnetMessageViewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d15d36')) {
      api.createRecord('74d15d36', component.options)
    } else {
      api.reload('74d15d36', component.options)
    }
    module.hot.accept("./PnetMessageViewSideMenu.vue?vue&type=template&id=74d15d36", function () {
      api.rerender('74d15d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pnetmessage/PnetMessageViewSideMenu.vue"
export default component.exports